import {memo, Suspense, useCallback} from 'react'

import {assignProblemInvestigations} from '../../../actions'
import {getBuildType} from '../../../selectors'
import type {BuildId, ProblemOccurrenceId} from '../../../types'
import {emptyArray} from '../../../utils/empty'
import {fetchProblemOccurrence} from '../../packages/BuildProblems/BuildProblems.actions'
import {getProblemOccurrencesById} from '../../packages/BuildProblems/BuildProblems.selectors'

import Mutes from './Mutes'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

type Props = {
  iconClassName?: string
  className?: string
  buildId: BuildId | null | undefined
  problemOccurrenceId: ProblemOccurrenceId
}

function ProblemMutes({className, iconClassName, buildId, problemOccurrenceId}: Props) {
  const dispatch = useAppDispatch()

  const problemOccurrence = useAppSelector(state =>
    getProblemOccurrencesById(state, problemOccurrenceId),
  )
  const {build, problem, mute, currentlyMuted} = problemOccurrence ?? {}
  const {buildTypeId} = build ?? {}
  const {id: problemId} = problem ?? {}
  const {projectId} = useAppSelector(state => getBuildType(state, buildTypeId)) ?? {}

  const currentlyMutes = problem?.mutes?.mute ?? emptyArray

  const muteHandler = useCallback(() => {
    if (buildId != null && problemId != null) {
      const submitHandler = () => dispatch(fetchProblemOccurrence(problemOccurrenceId))
      dispatch(assignProblemInvestigations(problemId, buildId, true, submitHandler))
    }
  }, [dispatch, buildId, problemId, problemOccurrenceId])

  return (
    <Suspense>
      <Mutes
        className={className}
        iconClassName={iconClassName}
        projectId={projectId}
        buildTypeId={buildTypeId}
        currentlyMuted={currentlyMuted}
        mute={mute}
        currentlyMutes={currentlyMutes}
        muteHandler={muteHandler}
      />
    </Suspense>
  )
}

export default memo<Props>(ProblemMutes)
